export default __webpack_public_path__ + "static/media/HelveticaNeueBold.61acdee6.ttf";